import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ma",
  "use": "icon-icon-ma-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ma\">\n  <path fill=\"#c1272d\" d=\"M512 0H0v512h512z\" />\n  <path fill=\"none\" stroke=\"#006233\" stroke-width=\"12.5\" d=\"m256 191.4-38 116.8 99.4-72.2H194.6l99.3 72.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol